import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/esnext.global-this.js";
import { utils, ExtensionType, settings, extensions } from '@pixi/core';
import { checkDataUrl } from '../../utils/checkDataUrl.mjs';
import { checkExtension } from '../../utils/checkExtension.mjs';
import { LoaderParserPriority } from './LoaderParser.mjs';
var validWeights = ["normal", "bold", "100", "200", "300", "400", "500", "600", "700", "800", "900"];
var validFontExtensions = [".ttf", ".otf", ".woff", ".woff2"];
var validFontMIMEs = ["font/ttf", "font/otf", "font/woff", "font/woff2"];
function getFontFamilyName(url) {
  var ext = utils.path.extname(url);
  var name = utils.path.basename(url, ext);
  var nameWithSpaces = name.replace(/(-|_)/g, " ");
  var nameTitleCase = nameWithSpaces.toLowerCase().split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
  return nameTitleCase;
}
var loadWebFont = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Low
  },
  test: function test(url) {
    return checkDataUrl(url, validFontMIMEs) || checkExtension(url, validFontExtensions);
  },
  load: function load(url, options) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fonts, _options$data$family, _options$data, _options$data$weights, _options$data2, _options$data2$weight, _options$data3, fontFaces, name, weights, data, i, weight, font;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (globalThis.navigator.onLine) {
              _context.next = 2;
              break;
            }
            throw new Error("[loadWebFont] Cannot load font - navigator is offline");
          case 2:
            fonts = settings.ADAPTER.getFontFaceSet();
            if (!fonts) {
              _context.next = 20;
              break;
            }
            fontFaces = [];
            name = (_options$data$family = (_options$data = options.data) === null || _options$data === void 0 ? void 0 : _options$data.family) !== null && _options$data$family !== void 0 ? _options$data$family : getFontFamilyName(url);
            weights = (_options$data$weights = (_options$data2 = options.data) === null || _options$data2 === void 0 ? void 0 : (_options$data2$weight = _options$data2.weights) === null || _options$data2$weight === void 0 ? void 0 : _options$data2$weight.filter(function (weight) {
              return validWeights.includes(weight);
            })) !== null && _options$data$weights !== void 0 ? _options$data$weights : ["normal"];
            data = (_options$data3 = options.data) !== null && _options$data3 !== void 0 ? _options$data3 : {};
            i = 0;
          case 9:
            if (!(i < weights.length)) {
              _context.next = 19;
              break;
            }
            weight = weights[i];
            font = new FontFace(name, "url(".concat(encodeURI(url), ")"), _objectSpread(_objectSpread({}, data), {}, {
              weight: weight
            }));
            _context.next = 14;
            return font.load();
          case 14:
            fonts.add(font);
            fontFaces.push(font);
          case 16:
            i++;
            _context.next = 9;
            break;
          case 19:
            return _context.abrupt("return", fontFaces.length === 1 ? fontFaces[0] : fontFaces);
          case 20:
            console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font");
            return _context.abrupt("return", null);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  unload: function unload(font) {
    (Array.isArray(font) ? font : [font]).forEach(function (t) {
      return settings.ADAPTER.getFontFaceSet().delete(t);
    });
  }
};
extensions.add(loadWebFont);
export { getFontFamilyName, loadWebFont };